"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NoOptionsFoundMessage = function NoOptionsFoundMessage() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col justify-start text-left ml-[5px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-medium my-[20px] text-grey-75"
  }, "No providers found"), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-body-regular text-grey-50"
  }, "Please check your spelling or try a different search term"));
};
var _default = NoOptionsFoundMessage;
exports.default = _default;